export default __webpack_public_path__ + "static/media/Reina Casa.3fe8a85b.jpg";